export default __webpack_public_path__ + "static/media/assessment_icon_small.52c91695.svg";